import { useEffect, useState } from "react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

// Admin setup progress (team built? project staffed?). Shared across the app; refetch with refreshSetup().
let cache = null;
const subs = new Set();

const load = () =>
  api.get("/setup/status").then((r) => { cache = r.data; subs.forEach((fn) => fn(cache)); }).catch(() => {});

export const refreshSetup = () => load();

export function useSetupStatus() {
  const { user } = useAuth();
  const isAdmin = user?.role === "admin";
  const [status, setStatus] = useState(isAdmin ? cache : null);
  useEffect(() => {
    if (!isAdmin) return undefined;
    subs.add(setStatus);
    load();
    return () => subs.delete(setStatus);
  }, [isAdmin, user?.workspace_id]);
  return isAdmin ? status : null;
}
